<mat-accordion class="summary__payments">
	<mat-expansion-panel expanded="true">
		<mat-expansion-panel-header>
			<mat-panel-title>Terminy płatności</mat-panel-title>
		</mat-expansion-panel-header>
		<mat-card appearance="outlined">
			<mat-card-title>
				<div class="row justify-content-between">
					<div class="col">Terminy</div>
					@if (!paymentsTermsEdit && selectedPaymentTermKind === PaymentTermKind.PAYMENT) {
						<div class="col row">
							<div class="col text-end small">
								<p class="cursor-pointer card__action" (click)="setEditPaymentTerm()">
									<i class="fas fa-pencil"></i> edytuj terminy płatności
								</p>
							</div>
						</div>
					}
					@if (paymentsTermsEdit) {
						<div class="col text-end d-flex align-items-center justify-content-end">
							@if (savingPaymentTerms) {
								<mat-spinner diameter="24" class="mx-3"></mat-spinner>
							}
							<button
								mat-raised-button
								color="warn"
								class="mx-3"
								(click)="cancelEditPaymentTerm()"
								[disabled]="savingPaymentTerms"
							>
								Porzuć
							</button>
							<button
								mat-raised-button
								color="primary"
								(click)="savePaymentsTerms()"
								[disabled]="savingPaymentTerms"
							>
								Zapisz
							</button>
						</div>
					}
				</div>
			</mat-card-title>
			<mat-card-content>
				<mat-tab-group
					[selectedIndex]="selectedPaymentTermTabIndex"
					(selectedTabChange)="onPaymentTermTabChange($event)"
					animationDuration="0ms"
				>
					<mat-tab label="Płatności"></mat-tab>
					<mat-tab label="Zwrotów"></mat-tab>
					<mat-tab label="Prowizji"></mat-tab>
				</mat-tab-group>

				@if (!paymentsTermsEdit && matData.data.length) {
					<mat-table [dataSource]="matData">
						<ng-container matColumnDef="position">
							<mat-header-cell *matHeaderCellDef> LP </mat-header-cell>
							<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="date">
							<mat-header-cell *matHeaderCellDef outline> Data </mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.term | formatDateTime }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="condition">
							<mat-header-cell *matHeaderCellDef outline> Warunek </mat-header-cell>
							<mat-cell *matCellDef="let element">{{
								element.countKind === 'R'
									? 'pozostało do ' + (element.countValue | PercentValue) + '%'
									: (element.countKind === 'V'
											? (element.countValue | price)
											: (element.countValue | PercentValue)) + getUnit(element)
							}}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="amount">
							<mat-header-cell *matHeaderCellDef outline> Kwota </mat-header-cell>
							<mat-cell
								*matCellDef="let element"
								[matTooltip]="
									element.kind === 'R'
										? 'Oskar: ' +
											(element.value | price) +
											' ' +
											(element.currency | currencyCode) +
											', Agent: ' +
											(element.refundedByAgent | price) +
											' ' +
											(element.currency | currencyCode)
										: ''
								"
								>{{
									(element.kind === 'R' ? element.refundedByAgent + element.value : element.value)
										| price
								}}
								{{ element.currency | currencyCode }}</mat-cell
							>
						</ng-container>
						<ng-container matColumnDef="status">
							<mat-header-cell *matHeaderCellDef outline> Status </mat-header-cell>
							<mat-cell *matCellDef="let element" class="gap-5">
								<span>{{ element.status | paymentTermStatusLabel: element.kind }}</span>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="info">
							<mat-header-cell *matHeaderCellDef> </mat-header-cell>
							<mat-cell *matCellDef="let element; let i = index" class="gap-5 justify-content-end">
								<i
									*ngIf="element"
									class="fas fa-user tooltip-paymentsTerm"
									matTooltipPosition="left"
									[matTooltip]="element['_user']"
								></i>
							</mat-cell>
						</ng-container>
						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
					</mat-table>
				}

				@if (!paymentsTermsEdit && !matData.data.length) {
					<p class="text-center py-4 text-muted">{{ paymentTermsEmptyStateMessage }}</p>
				}

				@if (paymentsTermsEdit && selectedPaymentTermKind === PaymentTermKind.PAYMENT) {
					<div class="payments_terms_edit">
						@for (term of paymentsTerms; track term.id) {
							<mat-card class="d-flex flex-column bg-light my-3">
								<div class="w-100 text-end mb-2">
									<button
										mat-icon-button
										color="warn"
										matTooltip="Usuń ten termin płatności"
										(click)="removePaymentTerm(term)"
									>
										<i class="fas fa-times"></i>
									</button>
								</div>

								<div>
									<div class="row mb-2">
										<mat-form-field appearance="outline" class="daysBeforeDeparture w-50">
											<mat-label>Dni</mat-label>
											<input
												[ngModel]="term.days"
												(change)="calculateTermDate($event, term)"
												matInput
												type="number"
											/>
										</mat-form-field>

										<mat-form-field appearance="outline" class="example-form-field w-50">
											<mat-label>Data</mat-label>
											<input
												matInput
												[(ngModel)]="term.term"
												[matDatepicker]="datepicker"
												required
											/>
											<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
											<mat-datepicker #datepicker>
												<mat-datepicker-actions>
													<button mat-button matDatepickerCancel>Anuluj</button>
													<button mat-raised-button color="primary" matDatepickerApply>
														Zatwierdź
													</button>
												</mat-datepicker-actions>
											</mat-datepicker>
											<mat-hint align="start">MM/DD/YYYY</mat-hint>
											@if (!term.term) {
												<mat-error>To pole jest wymagane </mat-error>
											}
										</mat-form-field>
									</div>

									<div class="row mb-2">
										<mat-form-field appearance="outline" class="w-50">
											<mat-label>Sposób</mat-label>
											<mat-select
												[(ngModel)]="term.countKind"
												(ngModelChange)="
													term.countValue = convertPriceByKind(
														term.countValue,
														term.countKind
													)
												"
												(selectionChange)="calculateTermValue(term)"
												required
											>
												<mat-option [value]="PaymentTermCountKind.VALUE">kwotowo </mat-option>
												<mat-option [value]="PaymentTermCountKind.PERCENTAGE"
													>procentowo
												</mat-option>
												<mat-option
													[value]="PaymentTermCountKind.REMAINING_TO_THE_GIVEN_PERCENTAGE"
													>pozostało do x %
												</mat-option>
											</mat-select>
											@if (!term.countKind) {
												<mat-error>To pole jest wymagane </mat-error>
											}
										</mat-form-field>
										<mat-form-field class="w-50" appearance="outline">
											<mat-label>Wartość {{ term.countKind !== 'V' ? '(%)' : '' }}</mat-label>
											<input
												matInput
												type="number"
												min="0"
												required
												[ngModel]="
													term.countKind === 'V'
														? (term.countValue | price)
														: (term.countValue | PercentValue)
												"
												(ngModelChange)="
													term.countKind === 'V'
														? (term.countValue = convertToGrosze($event))
														: (term.countValue = convertToPermill($event))
												"
												(change)="calculateTermValue(term)"
											/>
											@if (!term.countValue) {
												<mat-error>To pole jest wymagane </mat-error>
											}
										</mat-form-field>
									</div>
								</div>

								<h5>
									Kwota:
									{{ term.value ?? 0 | price }}
									{{ term.currency | currencyCode }}
								</h5>
							</mat-card>
						}
						<button
							mat-raised-button
							color="primary"
							class="text-end d-block ms-auto mt-2"
							(click)="addNewPaymentTerm()"
						>
							Dodaj
						</button>
					</div>
				}

				<div class="spacer mt-5"></div>
				<mat-card-title>
					<div class="row justify-content-between">
						<div class="col-9">Płatności</div>
						<div class="col row">
							<div class="col text-end small card__action text-end">
								<p class="cursor-pointer" (click)="openDialog()">
									<i class="fas fa-plus-circle"></i> dodaj płatność
								</p>
							</div>
						</div>
					</div>
				</mat-card-title>
				<mat-table
					[dataSource]="matPaymentData"
					matSort
					matSortActive="id"
					matSortDirection="asc"
					*ngIf="payments && payments.length"
				>
					<ng-container matColumnDef="position">
						<mat-header-cell *matHeaderCellDef> LP </mat-header-cell>
						<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
					</ng-container>
					<ng-container matColumnDef="date">
						<mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
						<mat-cell *matCellDef="let element">{{ element.payment | formatDateTime }}</mat-cell>
					</ng-container>
					<ng-container matColumnDef="kind">
						<mat-header-cell *matHeaderCellDef outline> Rodzaj </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{ element.kind.description }}
							@if (element.receivingOrganization) {
								<i
									[matTooltip]="element.receivingOrganization.shortName"
									class="fa-solid fa-money-check-dollar mx-1"
								></i>
							}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="status">
						<mat-header-cell *matHeaderCellDef outline> Status </mat-header-cell>
						<mat-cell class="ps-2 fs-5" *matCellDef="let element">
							<ng-container [ngSwitch]="element.status">
								<i *ngSwitchCase="PaymentStatus.COMPLETED" class="fas fa-check"></i>
								<i *ngSwitchCase="PaymentStatus.IN_PROGRESS" class="far fa-clock"></i>
								<i *ngSwitchCase="PaymentStatus.CANCELED" class="fas fa-times"></i>
							</ng-container>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="amount">
						<mat-header-cell *matHeaderCellDef outline> Kwota </mat-header-cell>
						<mat-cell *matCellDef="let element" class="position-relative">
							{{ element.amount | price }}
							{{ element.currency | currencyCode }}

							<i
								*ngIf="element"
								class="fas fa-user ps-3 tooltip-payments"
								matTooltipPosition="left"
								[matTooltip]="element['_user']"
							></i>
							<button
								mat-icon-button
								class="position-absolute payment-menu-button"
								[matMenuTriggerFor]="menu"
								style="right: 15px"
							>
								<i class="fa fa-ellipsis-vertical cursor-pointer"></i>
							</button>
							<mat-menu #menu="matMenu">
								<button mat-menu-item (click)="openPaymentDetails(element, false)">
									<span>Edytuj</span>
								</button>
								<button
									*ngIf="element.kind.id === PaymentKindId.CASH"
									mat-menu-item
									(click)="openPaymentDetails(element, true)"
								>
									<span>Generuj potwierdzenie wpłaty</span>
								</button>
								<button
									mat-menu-item
									class="payment-delete-button"
									(click)="deletePayment(element.id)"
									[disabled]="isNotDeletablePayment(element)"
								>
									<span>Usuń</span>
								</button>
							</mat-menu>
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedPaymentColumns"></mat-header-row>
					<mat-row
						[ngClass]="{
							'text-decoration-line-through': row.status === PaymentStatus.CANCELED,
						}"
						*matRowDef="let row; columns: displayedPaymentColumns"
					></mat-row>
				</mat-table>
				<button
					class="mat-custom-button mt-2 payments-visibility"
					color="primary"
					mat-raised-button
					*ngIf="payments.length && isPaymentsButtonVisible"
					(click)="showAllPayments()"
				>
					<span *ngIf="!isAllPaymentsShown; else hideAllPayments">Pokaż wszystkie płatności</span>
					<ng-template #hideAllPayments> Ukryj płatności </ng-template>
				</button>
			</mat-card-content>
			<mat-card-footer class="pe-4 text-end" *ngIf="payments.length">
				<p>
					Zapłacono: {{ reservation.paidAmount | price }}
					{{ reservation.currency.id | currencyCode }}
				</p>
			</mat-card-footer>
		</mat-card>
	</mat-expansion-panel>
</mat-accordion>
